import React from 'react'

import DocumentList from 'app/shared_components/document_list/document_list'

import 'app/agency/branding_uploader/style.scss'

const BrandingUploader = ({
  header = '',
  logoType,
  brandingURL = '',
  agencyGUID = '',
  error = '',
  onUploadBranding,
  onRemoveBranding,
  brandingImgClass = '',
  brandingRequirement = '',
  validationError = '',
  hideHeader = false,
  disabled = false,
}) => {
  return (
    <div className="branding-uploader ">
      {!hideHeader ? (
        <div className="branding-header">
          <h5>{header}</h5>
          {!brandingURL && <p>{brandingRequirement}</p>}
        </div>
      ) : null}
      {!brandingURL ? (
        <DocumentList
          addDocument={(documentType) =>
            onUploadBranding(logoType, agencyGUID, documentType)
          }
          documentType={logoType}
          responseText={error}
          disabledUpload={disabled}
          isFromAgencyBranding
        />
      ) : (
        <div className="branding-display">
          <img
            className={brandingImgClass}
            src={brandingURL}
            alt={`Agency ${header}`}
          />
          {!disabled && (
            <span
              className="blue-link-style form-input-text mt8"
              onClick={() => onRemoveBranding(logoType, agencyGUID)}
              role="button"
              tabIndex="0"
            >
              Remove
            </span>
          )}
        </div>
      )}
      {validationError && (
        <div className="height30 ">
          <div className="standard-error-box">{validationError}</div>
        </div>
      )}
    </div>
  )
}

export default BrandingUploader
